import axios from 'axios';
import * as actionTypes  from './types';

export const fetchUser = () => async dispatch => {	
	const res = await axios.get('/api/current_user');
	dispatch({
			type: actionTypes.FETCH_USER,
			payload: res.data
		});
	
}

export const fetchIssuer = () => async dispatch => {
	const res = await axios.get('/api/issuers');
	dispatch({
		type: actionTypes.FETCH_ISSUER,
		payload: res.data
	})
}

export const updateIssuer = (issuer) => async dispatch => {
	const res = await axios.post('/api/issuers',issuer,{
    'Content-Type': `multipart/form-data; boundary=${issuer._boundary}`,
	});
	dispatch({
		type: actionTypes.UPDATE_ISSUER,
		payload: res.data
	})
}


export const fetchBadgeClasses = (params) => async dispatch => {
	const res = await axios.get(`/api/badgeclasses`,{
		params
	});
	dispatch({
		type: actionTypes.FETCH_BADGECLASSES,
		payload: res.data
	})
}

export const fetchBadgeClass = (id) => async dispatch => {
	const res = await axios.get(`/api/badgeclasses/${id}`);
	dispatch({
		type: actionTypes.FETCH_BADGECLASS,
		payload: res.data
	})
}

export const createBadgeClass = (badgeClass) => async dispatch => {
	const res = await axios.post('/api/badgeclasses',badgeClass,{
    'Content-Type': `multipart/form-data; boundary=${badgeClass._boundary}`,
	});
	dispatch({
		type: actionTypes.CREATE_BADGECLASS,
		payload: res.data
	})
}

export const updateBadgeClass = (id,badgeClass) => async dispatch => {
	const res = await axios.put(`/api/badgeclasses/${id}`,badgeClass,{
    'Content-Type': `multipart/form-data; boundary=${badgeClass._boundary}`,
	});
	dispatch({
		type: actionTypes.UPDATE_BADGECLASS,
		payload: res.data
	})
}



export const fetchAssertions = (badgeClassId) => async dispatch => {
	const res = await axios.get(`/api/badgeclasses/${badgeClassId}/assertions`);
	dispatch({
		type: actionTypes.FETCH_ASSERTIONS,
		payload: res.data
	})
}

export const fetchAssertion = (id) => async dispatch => {
	const res = await axios.get(`/api/assertions/${id}`);
	dispatch({
		type: actionTypes.FETCH_ASSERTION,
		payload: res.data
	})
}


export const importAssertions = (body) => async dispatch => {
	const res = await axios.post('/api/import-assertions',body);
	dispatch({
		type: actionTypes.IMPORT_ASSERTIONS,
		payload: res.data
	})
	return true
}

export const createAssertion = (assertion) => async dispatch => {
	const res = await axios.post('/api/assertions',assertion);
	dispatch({
		type: actionTypes.CREATE_ASSERTION,
		payload: res.data
	})
}

export const updateAssertion = (id,assertion) => async dispatch => {
	const res = await axios.put(`/api/assertions/${id}`,assertion);
	dispatch({
		type: actionTypes.UPDATE_ASSERTION,
		payload: res.data
	})
}


// WEBPACK FOOTER //
// ./src/actions/index.js